import { IconArrowDownFull, IconCalendar } from '@/theme/icons';
import { endOfTheWeek, startOfTheMonth } from '@/utils/calendar';
import { getDateFnsLocale } from '@/utils/dateLocale';
import rem from '@/utils/rem';
import { Button, HStack, Icon, Text } from '@chakra-ui/react';
import { format } from 'date-fns';
import { RefObject, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  selectedDate: Date;
  showCalendarIcon?: boolean;
  showDatePicker?: boolean;
  onDatePickerOpen?: () => void;
  borderColor?: string;
};

const InnerDate = forwardRef(
  (
    {
      selectedDate,
      showCalendarIcon = false,
      showDatePicker = false,
      onDatePickerOpen,
      borderColor = 'stroke-primary',
    }: Props,
    ref,
  ) => {
    const { i18n } = useTranslation('MonthYearNavigator');
    const locale = getDateFnsLocale(i18n.language);
    const currentMonth = selectedDate && format(startOfTheMonth(selectedDate), 'MMMM', { locale });
    const endDateYear = selectedDate && format(endOfTheWeek(selectedDate), 'yyyy', { locale });

    if (showDatePicker) {
      return (
        <Button
          ref={ref as RefObject<HTMLButtonElement>}
          justifyContent="center"
          gap={rem(8)}
          height="full"
          minHeight={rem(32)}
          borderWidth={rem(1)}
          borderStyle="solid"
          borderColor={borderColor}
          borderRadius={rem(4)}
          backgroundColor="background-primary"
          onClick={() => onDatePickerOpen && onDatePickerOpen()}
          paddingX={rem(12)}
          paddingY={rem(3)}
          variant="ghost"
        >
          {showCalendarIcon && <Icon as={IconCalendar} boxSize={rem(14)} />}
          <Text as="span" textStyle={{ base: 'mediumBlack', lg: 'largeBlack' }}>
            {`${currentMonth}, ${endDateYear}`}
          </Text>

          <Icon as={IconArrowDownFull} boxSize={rem(7)} />
        </Button>
      );
    }

    return (
      <HStack
        textStyle={{ base: 'mediumBlack', lg: 'largeBlack' }}
        justifyContent="center"
        gap={rem(8)}
        width={rem(208)}
        height="full"
        minHeight={rem(32)}
        borderWidth={rem(1)}
        borderStyle="solid"
        borderColor={borderColor}
        borderRadius={rem(4)}
        backgroundColor="background-primary"
        paddingX={rem(8)}
      >
        {showCalendarIcon && <Icon as={IconCalendar} boxSize={rem(14)} />}
        <Text as="span">{`${currentMonth}, ${endDateYear}`}</Text>
      </HStack>
    );
  },
);
export default InnerDate;
